<template>
    <div class="modal-card" style="width: auto; overflow-y: auto;">

        <header class="modal-card-head">
            <p class="modal-card-title">{{$tc('MODALNOTIFICACAO.TITULO', this.listaNotificacoes.length) }}                
            </p>
            <b-button v-if="hasNotifications" icon-left="delete" class="is-danger is-small" @click="apagarTodasAsNotificacoes();">{{$t('MODALNOTIFICACAO.APAGARTODAS')}}</b-button>
                        
        </header>
        <section class="modal-card-body list is-paddingless is-marginless">
            
            <div class="list-item p-2 "
                 v-for="item in listaNotificacoes" :key="item.id">
                <div class="tags has-addons is-marginless">                    
                    <span  v-if="item.unidadeId>0" class="tag is-primary"> <b>{{ item.unidadeNome}}</b> </span>
                    <span v-if="item.tipo==1" class="tag is-warning"> Alerta </span>
                    <span v-else class="tag is-info">Aviso</span>
                    <span class="tag">{{ $formatDate(item.datahora, 'DD/MM/YYYY HH:mm:ss') }}</span>
                    <a class="tag is-danger is-delete" @click="apagarNotificacao(item.id);" :title="$t('MODALNOTIFICACAO.APAGAR')"></a>
                </div>
                <p class="is-paddingless has-text-black	mb-2">{{ item.descricao }}
                         

                </p>
                  
                <hr class="m-0">
            </div>
        </section>
        <footer  class="modal-card-foot">
            <button  class="button" type="button" @click="closeModal">{{$t('MODALNOTIFICACAO.FECHAR')}}</button>                    
        </footer>
    </div>
</template>



<script>
    import { mapState } from 'vuex'    
    import http from '@/http'
    export default {
        data() {
            return {                                
                listaNotificacoes: [],                 

            }
        },
        mounted() {
            this.loadNotificacoesFuncionario();                                 
        },        
        computed: {
            hasNotifications() {
                return this.listaNotificacoes.length > 0;
            },
            ...mapState([                
                'usuario'
            ]),            
        },
        methods: {
            closeModal() {
                this.$emit('close')
            },
            verHistorico() {
                this.closeModal()
                this.$router.push({ name: 'notificacaoUsuarioLogado', params: { funcionarioId: this.usuario.funcionarioId} })
            },
     
            abrirGuiaMensagem(guiaId,unidadeId,status){
                if(status==0){
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId,guiaList:true}})
                }else if (status == 1){
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId,guiaList:true }})
                }else if(status == 5){
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId,guiaList:true }})
                }else{
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId,guiaList:true}})
                }
                
                this.closeModal();
            },
            abrirGuia(guiaId,unidadeId,status){

                if(status==0){
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId}})
                }else if (status == 1){
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId,fluxoVenda:true }})
                }else if(status == 5){
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId,fluxoVenda:true }})
                }else{
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId}})
                }
                
                this.closeModal();

            },
            abrirGuiaAstec(astecId,unidadeId){
                this.$router.push({ name: 'guia-astec', params: { id: astecId, atualizarUnidadeId:unidadeId}})
                this.closeModal();
            },
            procurarCliente(nomeCliente){
                
                this.$router.push({ name: 'guia-list', query: { procurar: nomeCliente}})

                this.closeModal();

            },            
            loadNotificacoesFuncionario() {
                
                http.get('/api/notificacao/RetornaNotificacoesFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                        .then(res => res.data)
                        .then(data => {   
                        
                        this.listaNotificacoes = data;
                        
                    })
                    .catch((error) => {                        
                        throw error
                    }).finally(() => {
                        this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO',this.listaNotificacoes.length)              
                    })  
                  
                
            },          
         
            async apagarTodasAsNotificacoes() {

                this.$buefy.dialog.confirm({
                    title: this.$t('SISTEMA.ATENCAO'),
                    message: 'Deseja apagar todas notificações?',
                    cancelText: 'Não',
                    confirmText: 'Sim', 
                    type:"is-danger",                      
                    hasIcon: true,                                         
                    onConfirm: () => {   


                            this.listaNotificacoes.forEach((n) => {

                                http.get('/api/notificacao/DesativarNotificacao?idNotificacao=' + n.id )
                                        .then(res => res.data)
                                        .then(() => {                           
                                        return true;                        
                                    })
                                    .catch((error) => {                        
                                        throw error
                                    });

                            });
                            setTimeout(() => {this.loadNotificacoesFuncionario()},1000);                                       
                            
                    },
                    onCancel: () => {
                        return true
                    },
                })   

                
            },
            apagarNotificacao(id) {
                
                http.get('/api/notificacao/DesativarNotificacao?idNotificacao=' + id )
                        .then(res => res.data)
                        .then(() => {                           
                        return true;                        
                    })
                    .catch((error) => {                        
                        throw error
                    }).finally(() => {
                        this.loadNotificacoesFuncionario();
                    })  

            }
        }
    }
</script>
